import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChannelComponent } from './components/channel/channel.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LoginComponent } from './components/login/login.component';
import { WrapperComponent } from './components/wrapper/wrapper.component';
import { TradeboardListComponent } from './components/tradeboard-list/tradeboard-list.component';
import { TradeboardComponent } from './components/tradeboard/tradeboard.component';
import { UsersComponent } from './components/users/users.component';
import { BrokersComponent } from './components/brokers/brokers.component';
import { DataCollectionComponent } from './components/data-collection/data-collection.component';
import { SettingsComponent } from './components/settings/settings.component';
import { LogsComponent } from './components/logs/logs.component';
import { StrategyComponent } from './components/strategy/strategy.component';
import { InstrumentComponent } from './components/instrument/instrument.component';
import { ThreadComponent } from './components/thread/thread.component';
import { ReportAlertsComponent } from './components/report-alerts/report-alerts.component';
import { MonthlyReportComponent } from './components/monthlyreport/monthlyreport.component';
import { CONSTANTS } from './constants';
import { OrderPositionsComponent } from './components/order-positions/order-positions.component';

const routes: Routes = [
  {
    path: '', component: LoginComponent
  },
  {
    path: CONSTANTS.URI_PATH.TAH, component: WrapperComponent,
    children: [
      { path: CONSTANTS.URI_PATH.BROKERS, component: BrokersComponent },
      { path: CONSTANTS.URI_PATH.CHANNEL, component: ChannelComponent },
      { path: CONSTANTS.URI_PATH.LOGS, component: LogsComponent },
      { path: CONSTANTS.URI_PATH.MONTHLY_REPORT, component: MonthlyReportComponent },
      { path: CONSTANTS.URI_PATH.REPORT_ALERTS, component: ReportAlertsComponent },
      { path: CONSTANTS.URI_PATH.SETTINGS, component: SettingsComponent },
      { path: CONSTANTS.URI_PATH.THREAD, component: ThreadComponent },
      { path: CONSTANTS.URI_PATH.ENTITY_STRATEGY, component: StrategyComponent },
      { path: CONSTANTS.URI_PATH.ENTITY_INSTRUMENTS, component: InstrumentComponent },
      { path: CONSTANTS.URI_PATH.ORDER_POS, component: OrderPositionsComponent },
      { path: CONSTANTS.URI_PATH.TRADEBOARD, component: TradeboardComponent },
      { path: CONSTANTS.URI_PATH.TBLIST, component: TradeboardListComponent },
      { path: CONSTANTS.URI_PATH.USERS, component: UsersComponent },
      { path: CONSTANTS.URI_PATH.DATA_COLLECTION, component: DataCollectionComponent },
    ]
  },
  {
    path: CONSTANTS.URI_PATH.CLIENT, component: WrapperComponent,
    children: [
      { path: CONSTANTS.URI_PATH.BROKERS, component: BrokersComponent },
      { path: CONSTANTS.URI_PATH.DASHBOARD, component: DashboardComponent },
      { path: CONSTANTS.URI_PATH.LOGS, component: LogsComponent },
      { path: CONSTANTS.URI_PATH.SETTINGS, component: SettingsComponent },
      { path: CONSTANTS.URI_PATH.THREAD, component: ThreadComponent },
      { path: CONSTANTS.URI_PATH.TRADEBOARD, component: TradeboardComponent },
      { path: CONSTANTS.URI_PATH.TBLIST, component: TradeboardListComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
